import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { MessageService } from '../_services';
import * as MessageActions from '../_actions/message';

@Injectable({
  providedIn: 'root',
})
export class MessageEffects {
  loadMessages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MessageActions.loadMessages),
      mergeMap(() =>
        this.messageService.getMessages().pipe(
          map((messages) => MessageActions.loadMessagesSuccess({ messages })),
          catchError((error) => of(MessageActions.loadMessagesFailure({ error })))
        )
      )
    )
  );

  addMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MessageActions.addMessage),
      mergeMap(({ message }) =>
        this.messageService.saveMessage(message).pipe(
          map((savedMessage) => MessageActions.addMessageSuccess({ message: savedMessage })),
          catchError((error) => of(MessageActions.addMessageFailure({ error })))
        )
      )
    )
  );

  updateMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MessageActions.updateMessage),
      mergeMap(({ message }) =>
        this.messageService.saveMessage(message).pipe(
          map((updatedMessage) => MessageActions.updateMessageSuccess({ message: updatedMessage })),
          catchError((error) => of(MessageActions.updateMessageFailure({ error })))
        )
      )
    )
  );

  deleteMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MessageActions.deleteMessage),
      mergeMap(({ id }) =>
        this.messageService.deleteMessage(id).pipe(
          map(() => MessageActions.deleteMessageSuccess({ id })),
          catchError((error) => of(MessageActions.deleteMessageFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private messageService: MessageService
  ) {}
}
